<script setup lang="ts">

import Icon from "@/core/components/icon/Icon.vue";
import {ChevronRight} from "@lucide/vue";
import {storeToRefs} from "pinia";
import {useExtensionStore} from "@/stores/extension.store";
import {computed} from "vue";
import {pluralize} from "../../core/filters/Pluralize";

const {extensions} = storeToRefs(useExtensionStore());

const newExtensions = computed(() => {
    return extensions.value?.filter(extension => {
        return extension.is_new;
    }) ?? [];
});
</script>

<template>
  <div class="relative flex flex-col">
    <div class="border-[1.5px] border-primary bg-white hover:border-primary/50 rounded-lg flex items-center gap-2 p-2 z-10">
      <Icon name="mdi-view-grid-plus-outline" color="#DDDDF5" :size="40" />
      <p>Voir les modules</p>
      <ChevronRight class="w-6 text-gray-300 ml-4" />
    </div>
    <div v-if="newExtensions.length" class="bg-primary self-end rounded-b-lg px-2 pb-0.5 pt-2 relative -top-1.5">
      <p class="font-black text-[#FBDE39] text-xs flex items-center">
        NEW ✨ <span class="text-white ml-2">{{ newExtensions.length }} {{ pluralize("module", newExtensions.length) }}</span>
      </p>
    </div>
  </div>
</template>

<style scoped>

</style>
